import { safePromise } from "../../../Helpers/Functions/promise"
import { APIAppTemplateModel } from "../../../Models/API/AppTemplateModel"
import { MainThunkDispatch } from "../../../Reducers"
import { apiEndpoints } from "../../../Routes/api"
import { apiFetch } from "../../Client/NetworkActions"
import { MarketplaceAppType } from "../../Types"

export const getTemplateByName =
    (templateName: string) => async (dispatch: MainThunkDispatch) => {
        const { data, error } = await safePromise(
            dispatch(
                apiFetch<APIAppTemplateModel>(
                    `GET_TEMPLATE_BY_NAME_${templateName}`,
                    apiEndpoints.getTemplateByName({ templateName })
                )
            )
        )

        if (data === undefined || error !== undefined) {
            return
        }

        dispatch({ type: MarketplaceAppType.setTemplate, payload: data })
        return data
    }
